import { computed, onMounted, onUnmounted, reactive, ref } from 'vue';

const TOAST_EVENT = 'jw-toast';
const AUTO_DISMISS_MS = 7000;

// Module scope is page scope here: every JWX app on a host page shares this
// chunk instance (same property useUpdateKey.js and useFetch.js rely on).
const toasts = reactive([]); // { id, key, type, title, content, contentHtml, timer }
const hostIds = ref([]); // mounted ToastHost instances, first one wins
let uid = 0;
let hostUid = 0;
let busBound = false;

function clear(idOrKey) {
  const index = toasts.findIndex((t) => t.id === idOrKey || (t.key && t.key === idOrKey));

  if (index === -1) return;

  clearTimeout(toasts[index].timer);
  toasts.splice(index, 1);
}

function toast(settings = {}) {
  const { key = null, type, title, content, contentHtml, autoDismiss = true } = settings;
  const existing = key && toasts.find((t) => t.key === key);

  if (existing) return { id: existing.id, clear: () => clear(existing.id) };

  const id = ++uid;
  const entry = { id, key, type, title, content, contentHtml, timer: null };

  if (autoDismiss) entry.timer = setTimeout(() => clear(id), AUTO_DISMISS_MS);

  toasts.push(entry);

  return { id, clear: () => clear(id) };
}

function bindEventBus() {
  if (busBound || !window.$EventBus) return;

  busBound = true;
  // Legacy payloads are { type, title?, content? } — plain text only, never contentHtml.
  window.$EventBus.addEventListener(TOAST_EVENT, (event) => toast(event.detail));
}

export function useToaster() {
  return { toast, clear };
}

// ToastHost.vue only
export function useToastHost() {
  const id = ++hostUid;
  const isActiveHost = computed(() => hostIds.value[0] === id);

  onMounted(() => {
    hostIds.value.push(id);
    bindEventBus();
  });

  onUnmounted(() => {
    hostIds.value = hostIds.value.filter((h) => h !== id);
  });

  return { toasts, clear, isActiveHost };
}
